<template>
  <section>
    <el-form class="form_cls" :inline="true" :model="filters" @submit.native.prevent>
      <!-- <el-form-item label="">
        <el-input v-model="filters.key" :style="isMobile ? 'width: 230px !important;' : ''" placeholder="医院名称/任职机构"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <!-- <el-form-item v-for="item in buttonList" v-bind:key="item.id"> -->
      <!-- 这里触发点击事件 -->
      <!-- <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item> -->
      <!-- <el-form-item> -->
      <el-collapse class="collapsessss" accordion v-model="collapses_val">
        <el-collapse-item :name="0">
          <template slot="title">
            <div style="display: flex; justify-content: space-between; width: 100%">
              <span>达成率汇总</span>
              <!-- <div>
                审批状态：
                <span style="color: #6170d7; font-size: 12px">
                  {{
                    sionsummary_list.approvalStatus == 0
                      ? '待提交'
                      : sionsummary_list.approvalStatus == 1
                      ? '待审批'
                      : sionsummary_list.approvalStatus == 2
                      ? '审核通过'
                      : sionsummary_list.approvalStatus == 3
                      ? '审核未通过'
                      : ''
                  }}
                </span>
              </div> -->
            </div>
          </template>
          <div style="margin-left: 5px; margin-bottom: 10px">
            <div style="font-size: 12px; margin-bottom: 0px">
              <span>YTD{{ now_Month }}月-片数/达成：</span>
              <!-- <span style="color: #00b4ff"> -->
              {{ currency(sionsummary_list.ytdNumberSum) }} / {{ (Number(sionsummary_list.ytdNumberAchieved) * 100).toFixed(0) }}%
              <!-- </span> -->
            </div>
            <div style="font-size: 12px; margin-bottom: 10px">
              <span>YTD{{ now_Month }}月-金额/达成：</span>
              <!-- <span style="color: #00b4ff"> -->
              {{ currency(sionsummary_list.ytdAmountSum) }} / {{ (Number(sionsummary_list.ytdAmountAchieved) * 100).toFixed(0) }}%
              <!-- </span> -->
            </div>
          </div>
          <el-table
            :border="true"
            class="expends_cls2"
            :data="sionsummary_list.achievements"
            :header-cell-style="{
              'text-align': 'center',
              color: '#6170d7',
              backgroundColor: '#F5F7FA',
              padding: ' 0px 0 !important',
              fontSize: '10px',
            }"
            :cell-style="{ 'text-align': 'center' }"
            highlight-current-row
            header-cell-class-name="header_cell_name"
            @current-change="selectCurrentRow"
            v-loading="listLoading"
            @selection-change="selsChange"
            :style="isMobile ? 'width:100%' : 'width:500px'"
          >
            <el-table-column prop="categoryName" label="品类" width="65">
              <template slot-scope="scope">
                <span style="font-size: 10px">{{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" :label="now_Month + '月'">
              <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.number1) + '/' + toFixeds2(scope.row.achieve1) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.numberPrice1) + '/' + toFixeds2(scope.row.achievePrice1) }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="categoryName" :label="next_Month + '月'">
              <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.number2) + '/' + toFixeds2(scope.row.achieve2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.numberPrice2) + '/' + toFixeds2(scope.row.achievePrice2) }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <div v-if="sionsummary_list.message">驳回原因：{{ sionsummary_list.message }}</div>
          <!-- <div style="text-align: right">
            <el-button
              v-if="sionsummary_list.approvalStatus != 2 && currentuserrole != '产品线负责人' && currentuserrole != 'Leaders'"
              style="margin-top: 20px"
              :type="'primary'"
              @click.stop="submit_apply()"
            >
              提交审核
            </el-button>
          </div> -->
        </el-collapse-item>
      </el-collapse>
      <!-- </el-form-item> -->
    </el-form>

    <!--列表-->
    <div v-if="isMobile" class="table_top_div">
      <div style="background-color: white; border-radius: 5px; margin-bottom: 5px">
        <el-table
          :data="tabel_list"
          :border="true"
          cell-class-name="cell_class_name"
          header-cell-class-name="header_cell_name"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column v-if="currentuserrole == '小区经理'" prop="name" label="销售代表"></el-table-column>
          <el-table-column v-if="currentuserrole == '大区经理'" prop="name" label="小区"></el-table-column>
          <el-table-column v-if="currentuserrole == '产品线负责人' || currentuserrole == 'Leaders'" prop="name" label="大区"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template scope="scope">
              <!-- NotReported 未填报 Pending 待审批 Approved 审批通过 Rejected 驳回 -->
              <el-tag
                style="vertical-align: middle"
                size="mini"
                :type="
                  scope.row.status == 'Rejected'
                    ? 'danger'
                    : scope.row.status == 'Approved'
                    ? 'success'
                    : scope.row.status == 'NotReported'
                    ? 'warning'
                    : ''
                "
              >
                {{
                  scope.row.status == 'Rejected'
                    ? '已驳回'
                    : scope.row.status == 'Approved'
                    ? '审批通过'
                    : scope.row.status == 'NotReported'
                    ? '未填报'
                    : '待审批'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template scope="scope">
              <!-- <el-link
                v-if="scope.row.status == 'Pending' || scope.row.status == 'Rejected' || scope.row.status == 'NotReported'"
                :disabled="scope.row.status != 'Pending'"
                :type="scope.row.status == 'Pending' ? 'primary' : 'info'"
                @click="handleSp(scope.row)"
              >
                <i class="el-icon-edit"></i>
                审批
              </el-link> -->
              <el-link type="primary" @click="handleSp(scope.row, 'last_month')">
                <i class="el-icon-edit"></i>
                查看
              </el-link>
              <!-- <el-link
                v-if="(sionsummary_list.approvalStatus == 3 || sionsummary_list.approvalStatus == 0) && scope.row.status == 'Approved'"
                :type="'primary'"
                @click="handleSp(scope.row, 'bh')"
              >
                <i class="el-icon-edit"></i>
                驳回
              </el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import { calculateSum, loadings } from '@/utils'
import {
  estimate_getsubordinateapprovalrecords,
  estimate_exportdata,
  estimate_submitestimate,
  estimate_getsubmissionsummary,
  estimate_monthlyreportsummary,
  estimate_submitforreview,
  system_getcurrentuserrole,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
import EstimateListMobile from './mobile/EstimateListMobile'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve, EstimateListMobile },
  data() {
    return {
      currentuserrole: '',
      collapses_val: [0],
      sionsummary_list: [],
      next_Month: '',
      today_if: 0,
      upload_from: {},
      dialogVisible_approve: false,
      dialogVisible_upload: false,
      SP_IF: '',
      isMobile: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        currnrtTime: '',
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    handleSp(e, bh) {
      this.$router.push({
        path: '/Estimate/estimate_approve_details',
        query: {
          name: e.value,
          id: e.id,
          bh_if: bh,
          currentuserrole: this.currentuserrole,
        },
      })
    },
    submit_apply(e) {
      this.$confirm('确定提交审核？', '提示', {
        type: 'warning',
      }).then(async () => {
        const { data } = await estimate_submitforreview()
        if (data.code == 200) {
          this.$message({
            message: data.msg,
            type: 'success',
          })
          this.estimate_getsubmissionsummary_fn()
          this.getModules()
          //   this.system_getcurrentuserrole_fn()
        } else {
          this.$message({
            message: data.msg,
            type: 'error',
          })
        }
      })
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    toFixeds2(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(0) + '%'
      }
    },
    toFixeds(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(2) + '%'
      }
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      // return
      //   let para = {
      //     pageNumber: this.pageNumber,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      estimate_getsubordinateapprovalrecords(para).then((res) => {
        this.total = res.data.data.dataCount
        this.tabel_list = res.data.data.data
        this.listLoading = false
        this.SP_IF = this.$route.query.status
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async estimate_getsubmissionsummary_fn() {
      const { data } = await estimate_monthlyreportsummary(this.filters)
      this.sionsummary_list = data.data
      if (this.sionsummary_list.approvalStatus == 2) {
        this.today_if = 0
      }
    },
    async system_getcurrentuserrole_fn() {
      const { data } = await system_getcurrentuserrole()
      this.currentuserrole = data.data
    },
  },
  mounted() {
    // const now = new Date()
    // const currentMonth = now.getMonth()
    // const nextMonth = now.getMonth() + 1
    // console.log(nextMonth)
    this.now_Month = calculateSum(8)
    this.next_Month = calculateSum(9)
    // if (nextMonth > 12) {
    //   this.next_Month = 1
    // } else {
    //   this.next_Month = nextMonth
    // }
    // if (currentMonth == 0) {
    //   this.now_Month = 12
    // }
    this.filters.currnrtTime = calculateSum(7)
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    const date = new Date()
    const today = date.getDate()
    if (today > 19 && today < 24) {
      this.today_if = 2
    }
    this.estimate_getsubmissionsummary_fn()
    this.system_getcurrentuserrole_fn()
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }

    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
<style>
.expends_cls2 .cell {
  padding: 0 5px !important;
}
.expends_cls2 td.el-table__cell {
  padding: 1px 0 !important;
}
.collapsessss > .el-collapse-item > div:nth-child(1) {
  height: 40px !important;
  overflow: hidden !important;
}
</style>
